import { render, staticRenderFns } from "./AccesoRapido.vue?vue&type=template&id=2eb23748&scoped=true"
import script from "./AccesoRapido.vue?vue&type=script&lang=js"
export * from "./AccesoRapido.vue?vue&type=script&lang=js"
import style0 from "./AccesoRapido.vue?vue&type=style&index=0&id=2eb23748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb23748",
  null
  
)

export default component.exports